import { systemMailInFlight, systemMailStatusLabel } from "./SystemMailStatus";

// Delivery is authoritative; invited alone does not mean that mail was sent.
export const activationMailLabel = (status, l) =>
  `${l("Spieler freigegeben", "Player approved")} · ${systemMailStatusLabel(status, l("de", "en"))}`;

export const activationMailInFlight = systemMailInFlight;

export const intakeMailLabel = (status, l) => systemMailStatusLabel(status, l("de", "en"));
